import api from './api';

export const storesService = {
  // Get all stores (admin)
  getAll: async () => {
    const response = await api.get('/stores');
    return response.data;
  },

  // Get my store (customer)
  getMyStore: async () => {
    const response = await api.get('/stores/my');
    return response.data;
  },

  // Update my store (customer)
  updateMyStore: async (data) => {
    const response = await api.put('/stores/my', data);
    return response.data;
  },

  // Get store by ID (admin)
  getById: async (storeId) => {
    const response = await api.get(`/stores/${storeId}`);
    return response.data;
  },

  // Update store (admin)
  updateStore: async (storeId, data) => {
    const response = await api.put(`/stores/${storeId}`, data);
    return response.data;
  },

  // Delete store (admin)
  deleteStore: async (storeId) => {
    const response = await api.delete(`/stores/${storeId}`);
    return response.data;
  },

  // Get store preview (public)
  getPreview: async (subdomain) => {
    const response = await api.get(`/preview/${subdomain}`);
    return response.data;
  },

  // Admin stores endpoints
  admin: {
    getAll: async () => {
      const response = await api.get('/admin/stores');
      return response.data;
    },
    
    getById: async (storeId) => {
      const response = await api.get(`/admin/stores/${storeId}`);
      return response.data;
    },
    
    update: async (storeId, data) => {
      const response = await api.put(`/admin/stores/${storeId}`, data);
      return response.data;
    },
  },
};

export default storesService;
